import DecimalFormat from 'tools/DecimalFormat'
import { memoize } from 'tools/function'

export const localeRegex = /^[A-z][A-z]_[A-z][A-z]$/

const EMPTY_STRING_FORMAT = /^\s+$/

const JSON_OBJECT_REGEX = /"{(.*)}"$/ // e.g. "\"{\\\"store-order\\\":\\\"\\\"}\""
const JSON_ARRAY_REGEX = /"\[(.*)\]"$/ // e.g. "\"[]\""
const BOOLEAN_REGEX = /^(true|false)$/
const NUMBER_REGEX = /^-?\d+\.?\d*$/
const HTML_TAG_REGEX = /<\/?("[^"]*"|'[^']*'|[^>])*(>|$)/g

const MOBILE_USER_AGENT = /Mobi/i

export const parse = (string) => {
  try {
    if (string && string.match) {
      if (string.match(JSON_OBJECT_REGEX) || string.match(JSON_ARRAY_REGEX)) {
        return JSON.parse(JSON.parse(string))
      } else if (string.match(BOOLEAN_REGEX) || string.match(NUMBER_REGEX)) {
        return JSON.parse(string)
      }
    }
  } catch (_) {
    // TODO: log
  }

  return string
}

// https://stackoverflow.com/questions/6660977/convert-hyphens-to-camel-case-camelcase
export const toCamelCase = (string) => string !== null && string !== undefined ? (string + '').replace(/-([a-z])/g, (g) => g[1].toUpperCase()) : ''

// Transform __string__ to <b>string</b>
export const toTemplate = (string, template = () => ({})) => {
  if (string === undefined || string === null) return ''

  const splits = string.split(/__([^__]+)__/g)
  return splits.map((str, i) => (i % 2 === 0
    ? str
    : template(str)))
}

export const format = (string, func) => string && func ? string.replace(/{{(\w+)}}/g, func) : ''

export const pad = (str, length = 2, p = '0') =>
  str === undefined || str === null || str.length >= length ? str : new Array(length - str.length + 1).join(p) + str

const createFormatter = memoize((format) => (new DecimalFormat(format)))

export const formatMoney = (amount, currency, format) => (
  (currency && format && amount !== Infinity && amount !== -Infinity)
    ? (createFormatter(format).format(amount) || '').replace(/¤/, currency)
    : amount
)

export const formatDisplacement = (displacementInKm, format) => (
  (format && displacementInKm !== Infinity && displacementInKm !== -Infinity)
    ? (createFormatter(format).format(displacementInKm) || '').trim()
    : displacementInKm
)

export const getLang = (locale) => locale !== undefined && locale !== null ? locale.split('_')[0] : null

export const isMobileAgent = (userAgent) => MOBILE_USER_AGENT.test(userAgent)

export const tryParseJSON = (string) => {
  try {
    return JSON.parse(string)
  } catch (err) {
    return string
  }
}

export const percentageRegex = /^([0-9])+%$/

export const capitalizeFirstLetter = (string) => string.charAt(0).toUpperCase() + string.slice(1)

export const toLowerCase = (string) => typeof string === 'string' ? string.toLowerCase() : string

export const isEmpty = (value) => value === undefined || value === null || value === '' || EMPTY_STRING_FORMAT.test(value)

export const makeCombineString = (joint = ' ') => (...args) => [...args].filter(x => typeof x === 'string' || typeof x === 'number').join(joint)

export const combineString = makeCombineString(' ')

export const replaceAll = (string, search, replacement) => string.replace(new RegExp(search, 'g'), replacement)

export const getRegexFromString = (string) => {
  try {
    if (string) {
      const json = JSON.parse(string)
      return new RegExp(json.pattern, json.modifiers)
    }
  } catch (err) {
    console.error(err)
  }
}

export const stripHTMLChar = (string) => (string || '').replace(HTML_TAG_REGEX, '')
